import React from 'react';
import { convertFieldsToGraphqlVariables } from '../../graphql-helpers';
import { get } from 'immutadot';
import { parse } from 'date-fns';
import * as XLSX from 'xlsx';
import { useCampaignsQueryQuery } from "../../generated/graphql";
import { useSnackbar } from 'notistack';
import {useLocation} from "react-router";
import QueryString from "query-string";


function dateToExcel(inDate) {
    const returnDateTime = 25569.0 + ((inDate.getTime() - (inDate.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
    return returnDateTime.toString().substr(0, 5);
}
type QSP = {
    name:string,
    type:string,
    value:any
};

export const CreativeReport = ({ params, done }) => {
    const location = useLocation();
    const rawParsedQueryString = QueryString.parse(location.search);
    const queryStringArray:QSP[] = [];
    Object.entries(rawParsedQueryString).forEach(function ([k, v]) {
        const name = k.split('-');
        queryStringArray.push({name: name[0], type: name[1], value: v});
    });
    const gqlParams = convertFieldsToGraphqlVariables(queryStringArray);
    gqlParams.with_creative = true;
    //const toastId = 'cost-report';
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    enqueueSnackbar('Generating report', { key: 'GEN_REPORT' });
    const currency = { glyph: '£' };
    const query = useCampaignsQueryQuery({
        //useQuery(campaignsQuery,{
        variables: gqlParams,
        fetchPolicy: "network-only",
        onCompleted: (v) => {
            console.log('done', v);
            closeSnackbar('GEN_REPORT');
            enqueueSnackbar('Rendering report', { key: 'GEN_REPORT' });
            const pixPerLetter = 7;
            const rawValues = v.campaigns?.data||[];
            console.log("rawwwwwwwww", rawValues);
            const tableValues = [];
            rawValues.forEach(row => {
                if (!row.creativeStudio?.length) return;
                row.creativeStudio.forEach((cost) => {
                    const c = { ...cost };
                    c.campaign = row;
                    tableValues.push(c);
                });
            });
            console.log('values is', tableValues);
            const eData = [];
            const columns = [
              {
                accessor: "campaign.job_reference",
                header: "Job Ref",
              },
              {
                accessor: "campaign.status",
                header: "Status",
                width: "minmax(4em, max-content)",
                dataType: "default",
              },
              {
                accessor: "campaign.name",
                header: "Job Name",
                className: "column-width-wide-plus",
                dataType: "default",
              },
              {
                accessor: "campaign.clientCompany.sales_company",
                header: "Client",
                className: "column-width-wide-plus",
                dataType: "default",
              },
              {
                accessor: "campaign.salesTeam.name",
                header: "Sales Team",
                dataType: "default",
              },
              {
                accessor: "campaign.ourContact.name",
                header: "Account Manager",
                dataType: "default",
              },
              {
                accessor: "creativeStudioType.name",
                header: "Type",
              },
              {
                accessor: "creativeStudioTypeDetail.name",
                header: "Detail",
              },
              {
                accessor: "start_date",
                header: "Start Date",
              },
              {
                accessor: "end_date",
                header: "End Date",
              },
              {
                accessor: "campaignComponent.region.name",
                header: "Region Name",
              },
              {
                accessor: "campaignComponent.unit_value_local",
                header: "Unit Price",
                exportAs: "currency",
              },
              {
                accessor: "campaignComponent.qty",
                header: "Qty",
                exportAs: "number",
              },
              {
                accessor: "campaignComponent.value",
                header: "Total Cost",
                exportAs: "currency",
              },
            ];
            const worksheet = { '!ref': 'A1:' };
            let col = 1;
            const colwidths = [];
            columns.forEach((column) => {
                var header = column.headerRaw ? column.headerRaw : column.header;
                worksheet[String.fromCharCode(64 + col) + 1] = { t: 's', v: header };
                colwidths.push({ wpx: header.toString().length });
                col++;
            });
            worksheet['!ref'] = 'A1:' + String.fromCharCode(64 + col) + '1';
            eData.push(columns.map((column) => column.header));
            var rowIdx = 2;
            var lastCell = '';
            tableValues.forEach((row) => {
                let col = 1;
                columns.forEach((column) => {
                    const cell = { t: 's', v: undefined, f: undefined, w: undefined, z: undefined };
                    let value: any = null;
                    value = get(row, column.sort ? column.sort : column.accessor);
                    const rawValue = value;
                    if(column.accessor=='campaignComponent.value') {
                        let valueA = get(row, 'campaignComponent.unit_value_local');
                        let valueB = get(row, 'campaignComponent.qty');
                        value = (valueA??0) *(valueB??0);
                    }
                    switch (column.exportAs) {
                        case 'number':
                            cell.t = 'n';
                            cell.v = value;
                            if (isNaN(value) || value === null) {
                                cell.v = 0;
                            }
                            break;
                        case 'date-uk':
                            cell.t = 'n';
                            cell.z = 'dd/mm/yyyy';
                            var dateValue = parse(value, 'dd/MM/yyyy', new Date());
                            //console.log('parsing',value,parse(value, 'dd/MM/yyyy', new Date()),!!parse(value, 'dd/MM/yyyy', new Date()));
                            cell.v = isNaN(dateValue.getTime()) ? '' : dateToExcel(dateValue);
                            //value = parse(value, 'dd/MM/yyyy', new Date());
                            break;
                        case 'date-iso':
                            cell.t = 'n';
                            cell.z = 'dd/mm/yyyy';
                            //console.log('parsing',value,parse(value, 'yyyy-MM-dd', new Date()));
                            cell.v = dateToExcel(parse(value, 'yyyy-MM-dd', new Date()));
                            //value = parse(value, 'dd/MM/yyyy', new Date());
                            break;
                        case 'percentage':
                            cell.t = 'n';
                            //                        cell.v = parseFloat(value?value.replace('%', ''):'');
                            cell.z = '#.##"%"';
                            cell.v = value;
                            if (typeof value == 'number') {
                                cell.v = value / 100;
                            }
                            if (typeof value == 'string') {
                                cell.v = parseFloat(value ? value.replace('%', '') : '');
                            }
                            if (isNaN(cell.v) || cell.v == null) {
                                cell.v = 0;
                            }
                            //cell.w = value; 
                            //value = parseFloat(value.replace('%', ''));
                            break;
                        case 'currency':
                            cell.t = 'n';
                            cell.v = value;
                            if (typeof value == 'number') {
                                cell.v = value / 100;
                            }
                            if (typeof value == 'string') {
                                cell.v = parseFloat(value ? value.replace(/[^0-9\\.]/, '') : '');
                            }
                            if (isNaN(cell.v) || cell.v === null) {
                                cell.v = 0;
                            }
                            console.log('cell is', cell);
                            //                        if(!cell.v) { cell.v = value; }
                            cell.z = '"' + (currency?.glyph ? currency.glyph : '£') + '"' + '0.00';
                            //cell.w = value;
                            break;
                        case 'boolean':
                            if (typeof value == 'object') {
                                cell.v = rawValue ? 'Y' : 'N';
                            } else {
                                cell.v = value ? 'Y' : 'N';
                            }
                            break;
                        default:
                            if (typeof value == 'object') {
                                if (value) {
                                    value = value.toString();
                                    cell.v = value;
                                } else {
                                    cell.v = ''; value = '';
                                }
                            }
                            else {
                                cell.v = value;
                            }
                            break;
                    }
                    if (cell.v) {
                        colwidths[col - 1].wpx = Math.max(colwidths[col - 1].wpx, cell.v.toString().length);
                    }
                    lastCell = String.fromCharCode(64 + col++) + rowIdx;
                    worksheet[lastCell] = cell;
                    //newRow.push(value);
                });
                rowIdx++;
                //            return newRow;
            });
            worksheet['!ref'] = 'A1:' + lastCell;
            colwidths.forEach(v => { v.wpx = v.wpx * pixPerLetter; });
            console.log('widths', colwidths);
            worksheet['!cols'] = colwidths;
            console.log('worksheet is', worksheet);
            //if (eData.length > 1) {
            //const ws = XLSX.utils.aoa_to_sheet(eData);
            //var ws = XLSX.utils.aoa_to_sheet(eData);
            const wb = XLSX.utils.book_new();
            //var cell = ws['A2'];
            //console.log(worksheets);
            //worksheet['A2'] = {t:'s',v: 'TEST'};
            XLSX.utils.book_append_sheet(wb, worksheet, "SheetJS");
            XLSX.writeFile(wb, "sheetjs.xlsx");
            //}
            done();
        },
        onError: () => {
            closeSnackbar('GEN_REPORT');
            enqueueSnackbar('Error generating report', { key: 'GEN_REPORT', variant: 'error' });
            done();
        }
    });
    console.log(query);
    return [];
}